export default __webpack_public_path__ + "static/media/dinghy_smock.3f29f5ce.jpg";